import {Component, Input, OnInit} from '@angular/core';
import {V3Audio, V3AudioAnswerHolder, V3ExerciseSessionQuestion} from "../../../../cspa/model/v3/cspa";

@Component({
    selector: 'app-audio-result',
    templateUrl: './audio-result.component.html',
    styleUrls: ['./audio-result.component.scss'],
    standalone: false
})
export class AudioResultComponent  implements OnInit {
  @Input() questions: V3ExerciseSessionQuestion[] = []
  constructor() {
  }

  ngOnInit(): void {
  }


  getQuestion(q: V3ExerciseSessionQuestion) {
    const questionDef = q.questionDef as V3Audio
    return questionDef.audioTranscription
  }

  getStudentAnswer(q: V3ExerciseSessionQuestion) {
    const answerHolder = q.questionDef?.answerDef?.answerHolder as V3AudioAnswerHolder | null
    return answerHolder?.answer?.map(a => a.val.join("; ")) || "-"
  }

  getCorrectAnswer(q: V3ExerciseSessionQuestion) {
    const questionDef = q.questionDef as V3Audio
    return questionDef.answerDef.answer.map(a => a.val.join(", ")).join("; ")
  }

  isAnswerIncorrect(q: V3ExerciseSessionQuestion) {
    const answerHolder = q.questionDef?.answerDef?.answerHolder as V3AudioAnswerHolder | null
    return q.score == 0 && !!answerHolder
  }
}
